import { rolePermissions } from "./type.model"

const urlAllow = (u = '') => {
  let url = window.location.pathname
  let permissions = u?.permissions?.[0]
  let value = true
  let ext = rolePermissions.find(itm => url.includes(itm.url) || itm?.urls?.find(uitm => url.includes(uitm)))
  // alert(permissions?.[`read${ext.key}`]);
  if (ext || url?.includes('/marketing/seo/reporting')) {
    const permissionKey =
      ext?.key === "CheckinSettings" ? `edit${ext.key}` : `read${ext.key}`;
    value = permissions?.[permissionKey]
  }
  // console.log("url=",url)
  // console.log("ext=",ext)
  // console.log("value=",value)
  if (u?.role?.name == 'Admin') value = true
  return value
}

const permissionModel = { urlAllow }

export default permissionModel
